<template>
    <div v-if="userAttribute != null">
        <el-tabs v-if="showTab" v-model="selectedTabName" type="border-card" @tab-click="handleChangeTab" :before-leave="beforeLeave">
            <el-tab-pane :label="$t('message.title_ip_radio_information')" name="ipRadioInfo"></el-tab-pane>
            <el-tab-pane v-if="!isAdminUser" :label="$t('message.title_userGroup')" name="userGroup"></el-tab-pane>

            <!-- タブ : IP無線機情報 -->
            <template v-if="selectedTabName=='ipRadioInfo'">
                <div class="object-titlebox">
                    <div class="object-titlebox-right">
                        <template v-if="showMoveIpRadioCommand">
                            <button v-if="!tableView" class="transparent-button" type="button" v-on:click="showDialogAfterWritableCheck('MoveUser')"><img src="../../../../assets/move.svg"/><span class="normal-command-text" v-t="'message.common_action_move'"></span></button>
                        </template>
                        <template v-if="showAssignIpRadioSettingCommand">
                            <button v-if="!tableView" class="transparent-button" type="button" v-on:click="showDialogAfterWritableCheck('AssignIPRadioSetting')"><img src="../../../../assets/edit.svg"/><span class="normal-command-text" v-t="'message.common_action_setting_assign'"></span></button>
                        </template>
                        <template v-if="showEditIpRadioCommand">
                            <button class="transparent-button" type="button" v-on:click="showDialogAfterWritableCheck('EditIpRadio')"><img src="../../../../assets/edit.svg"/><span class="normal-command-text" v-t="'message.common_action_edit'"></span></button>
                        </template>
                    </div>
                </div>
                <table width=100%>
                    <tr class="objectitem-record"><td class="object-item" v-t="'message.item_userId'"></td><td class="object-value">{{ userAttribute.name }}</td></tr>
                    <tr class="objectitem-record"><td class="object-item" width=50%  v-t="'message.item_userDisplayName'"></td><td class="object-value">{{ userAttribute.displayName }}</td></tr>
                    <tr class="objectitem-record"><td class="object-item" v-t="'message.item_organization'"></td><td class="object-value">{{ userAttribute.organization }}</td></tr>
                    <tr class="objectitem-record"><td class="object-item" v-t="'message.item_job_title'"></td><td class="object-value">{{ userAttribute.title }}</td></tr>
                    <tr class="objectitem-record">
                        <td class="object-item" v-t="'message.item_option_interrupt_permission'"></td>
                        <td v-if="userAttribute.userOptions.interrupt" class="object-value" v-t="'message.value_present'"></td>
                        <td v-else class="object-value" v-t="'message.value_absent'"></td>
                    </tr>
                    <tr class="objectitem-record">
                        <td class="object-item" v-t="'message.item_option_speechToText'"></td>
                        <td v-if="userAttribute.userOptions.speechToText" class="object-value" v-t="'message.item_value_used'"></td>
                        <td v-else class="object-value" v-t="'message.item_value_nonUsed'"></td>
                    </tr>
                    <tr class="objectitem-record">
                        <td class="object-item" v-t="'message.item_option_translation'"></td>
                        <td v-if="userAttribute.userOptions.translation" class="object-value" v-t="'message.item_value_used'"></td>
                        <td v-else class="object-value" v-t="'message.item_value_nonUsed'"></td>
                    </tr>
                    <tr v-if="isVisibleUserOption('tracking')" class="objectitem-record">
                        <td class="object-item" v-t="'message.item_option_location_tracking'"></td>
                        <td v-if="userAttribute.userOptions.tracking" class="object-value" v-t="'message.item_value_used'"></td>
                        <td v-else class="object-value" v-t="'message.item_value_nonUsed'"></td>
                    </tr>
                    <tr class="objectitem-record"><td class="object-item" v-t="'message.item_ip_radio_Info_model'"></td><td class="object-value">{{ userAttribute.modelName }}</td></tr>
                    <tr class="objectitem-record"><td class="object-item" v-t="'message.item_ip_radio_Info_destination'"></td><td class="object-value">{{ userAttribute.destinationCode }}</td></tr>
                    <tr class="objectitem-record"><td class="object-item" v-t="'message.item_ip_radio_Info_serial_number'"></td><td class="object-value">{{ userAttribute.serialNumber }}</td></tr>
<!--                    <tr class="objectitem-record"><td class="object-item" v-t="'message.item_ip_radio_Info_custom_contract_number'"></td><td class="object-value">{{ userAttribute.contractNumber }}</td></tr>-->
                    <tr class="objectitem-record"><td class="object-item" v-t="'message.item_ip_radio_Info_plan_name'"></td><td class="object-value">{{ userAttribute.planName }}</td></tr>
                    <tr class="objectitem-record"><td class="object-item" v-t="'message.item_ip_radio_Info_option_name'"></td><td class="object-value">{{ userAttribute.optionName }}</td></tr>
                    <tr class="objectitem-record"><td class="object-item" v-t="'message.item_ip_radio_Info_primary_line'"></td><td class="object-value">{{ getPrimaryLineDisplay(userAttribute.primaryLine) }}</td></tr>
                    <tr class="objectitem-record"><td class="object-item" v-t="'message.item_ip_radio_Info_version'"></td><td class="object-value">{{ getVersionDisplay(userAttribute.version) }}</td></tr>
                    <tr class="objectitem-record"><td class="object-item" v-t="'message.item_ip_radio_Info_setting'"></td>
                        <td v-if="userAttribute.ipRadioSetting != null" class="object-value">{{ userAttribute.ipRadioSetting.model }} : {{ userAttribute.ipRadioSetting.displayName }}</td>
                        <td v-else class="object-value">未割り当て</td>
                    </tr>
                    <tr class="objectitem-record"><td class="object-item" >{{appData.customFieldName}}</td><td class="object-value">{{ userAttribute.customField1 }}</td></tr>
<!--                    <tr class="objectitem-record"><td class="object-item" v-t="'message.item_ip_radio_Info_management_number'"></td><td class="object-value">{{ userAttribute.managementNumber }}</td></tr>-->
                    <tr v-if="FEATURE_JKC_STUN" class="objectitem-record">
                        <td class="object-item" v-t="'message.item_ip_radio_Info_stun'"></td>
                        <td v-if="userAttribute.isStun" class="object-value" v-t="'message.item_stun_on'"></td>
                        <td v-else class="object-value" v-t="'message.item_stun_off'"></td>
                    </tr>

                </table>
                <div class="object-titlebox">
                    <div class="object-titlebox-left">
                        <span>{{ $t('message.item_detailed_information') }}</span>
                    </div>
                </div>
                <table width=100%>
                    <tr class="objectitem-record">
                        <td class="object-item" style="width: 50%">
                            <spn>{{ $t('message.item_usage_status') }}</spn>
                            <el-tooltip effect="dark" placement="top-start">
                                <div slot="content" style="text-align:left" v-html="$t('message.hint_usage_status')"/>
                                <img class="icon-help" style="height:15px" :src="require('@/assets/icon_help.svg')" alt=""/>
                            </el-tooltip>
                        </td>
                        <td class="object-value">{{ useStatus }}</td>
                    </tr>
                    <tr class="objectitem-record">
                        <td class="object-item" style="width: 50%">
                            <spn>{{ $t('message.item_use_start_date') }}</spn>
                        </td>
                        <td class="object-value">{{ useStartDate }}</td>
                    </tr>
                </table>
            </template>

            <!-- タブ : 参加できるグループ -->
            <template v-else-if="selectedTabName=='userGroup'">
                <div class="object-titlebox">
                    <div class="object-titlebox-left" v-t="{ path: 'message.title_groupOfUser', args: { name: userAttribute.displayName, groupCount: groupCount} }"></div>
                    <div class="object-titlebox-right">
                        <div v-if="talkGroupUsers.length==0">
                            <template v-if="showEditIpRadioGroupCommand">
                                <button class="transparent-button" type="button" @click="showDialogAfterWritableCheck('AddTalkGroupToUser')"><img src="../../../../assets/add_user.svg"/><span class="normal-command-text" v-t="'message.action_add_group_to_user'"></span></button>
                            </template>
                        </div>
                        <div v-else>
                            <template v-if="showEditIpRadioGroupCommand">
                                <button class="transparent-button" type="button" @click="showDialogAfterWritableCheck('AddTalkGroupToUser')"><img src="../../../../assets/edit.svg"/><span class="normal-command-text" v-t="'message.action_edit_group_of_user'"></span></button>
                            </template>
                        </div>
                    </div>
                    <el-form @submit.native.prevent="submit">
                        <el-input :placeholder="$t('message.place_holder_input_text')" v-model.trim="searchString" class="object-search-select" style="width:540px;" clearable @clear="clearSearchString()" :disabled="userSearchDisabled" >
                            <el-select class="search-item" v-model="condition" slot="prepend" @change="handleChangeSearchCondition()">
                                <el-option :label="$t('message.item_display_all')" value="all"></el-option>
                                <el-option :label="$t('message.item_groupId')" value="name"></el-option>
                                <el-option :label="$t('message.item_mandatory_yes')" value="mandatoryYes"></el-option>
                                <el-option :label="$t('message.item_mandatory_no')" value="mandatoryNo"></el-option>
                            </el-select>
                            <el-button class="search-button" slot="append" @click="filterTalkGroup()" v-t="'message.action_filter_items'"></el-button>
                        </el-input>
                    </el-form>
                </div>
                <div v-if="(loadingScreen == null) && usersTalkGroupExceededMax" class="object-titlebox">
                    <div class="error-message-text" v-t="{ path: 'message.info_exceeds_group_count', args: { count: talkGroupUsers.length } }"></div>
                </div>
                <table width=100% cellpadding=0 cellspacing=0>
                    <tr class="talkgroup-title">
                        <td class="talkgroup-item-header1" v-t="'message.item_groupId'"></td>
                        <template v-if="FEATURE_JKC_SETTING_JOINED_GROUP">
                            <td class="talkgroup-item-header2" v-t="'message.title_power_on'"></td>
                        </template>
                        <td class="talkgroup-item-header2" style="white-space: pre-wrap;" v-t="'message.title_default_listen_group'"></td>
                        <td class="talkgroup-item-header2" v-t="'message.title_mandatory'"></td>
                        <template v-if="FEATURE_JKC_EMERGENCY">
                            <td class="talkgroup-item-header2" v-t="'message.title_emergency_group'"></td>
                        </template>
                        <td class="talkgroup-item-header2" style="white-space: pre-wrap;" v-t="'message.title_default_second'"></td>
                        <template v-if="FEATURE_JKC_SETTING_JOINED_GROUP">
                            <td class="talkgroup-item-header2" style="white-space: pre-wrap;" v-t="'message.title_listen_only'"></td>
                        </template>
                        <td v-if="showDeleteIpRadioGroupCommand" class="talkgroup-item-header2" v-t="'message.common_action_delete'"></td>
                    </tr>
                    <tr class="talkgroup-item-record" v-for="(userTalkGroup,index) in talkGroupUsers">
                        <td v-if="userTalkGroup.userTenantId == userTalkGroup.tenantId" class="talkgroup-item1">{{ userTalkGroup.talkgroupName }}</td>
                        <td v-else class="talkgroup-item1">{{ userTalkGroup.talkgroupName }}( {{ userTalkGroup.talkgroupTenantName }} )</td>
                        <!-- 電源ON -->
                        <td v-if="FEATURE_JKC_SETTING_JOINED_GROUP" class="talkgroup-item2">
                            <label>
                              <input type="hidden" name="poweron" :value="userTalkGroup.powerOnFlag" />
                              <input class="custom-checkbox-input" name="poweron" value="True" type="checkbox">
                              <span v-if="userTalkGroup.powerOnFlag">
                                      <img class="action-icon" src="../../../../assets/icon_check_green.svg" @click="changePowerOnGroup(userTalkGroup)"/>
                                  </span>
                              <span v-else>
                                      <img class="action-icon" src="../../../../assets/icon_check_gray.svg" @click="changePowerOnGroup(userTalkGroup)"/>
                                  </span>
                            </label>
                        </td>
                        <!-- 聞く（デフォルト） -->
                        <td class="talkgroup-item2">
                            <label>
                              <input type="hidden" name="defaultlistentalkgroup" :value="userTalkGroup.defaultFlag" />
                              <input class="custom-checkbox-input" name="mandatory" value="True" type="checkbox">
                              <span v-if="userTalkGroup.defaultFlag">
                                      <img class="action-icon" src="../../../../assets/icon_check_green.svg" @click="changeDefaultListenTalkgroup(userTalkGroup)"/>
                                  </span>
                              <span v-else>
                                      <img class="action-icon" src="../../../../assets/icon_check_gray.svg" @click="changeDefaultListenTalkgroup(userTalkGroup)"/>
                                  </span>
                            </label>
                        </td>
                        <!-- 必須 -->
                        <td class="talkgroup-item2">
                            <label>
                                <input type="hidden" name="mandatory" :value="userTalkGroup.mandatoryFlag" />
                                <input class="custom-checkbox-input" name="mandatory" value="True" type="checkbox">
                                <span v-if="userTalkGroup.mandatoryFlag">
                                    <img class="action-icon" src="../../../../assets/icon_check_green.svg" @click="handleChangeMandatory(userTalkGroup)"/>
                                </span>
                                <span v-else>
                                    <img class="action-icon" src="../../../../assets/icon_check_gray.svg" @click="handleChangeMandatory(userTalkGroup)"/>
                                </span>
                            </label>
                        </td>
                        <!-- エマージェンシーグループ -->
                        <td v-if="FEATURE_JKC_EMERGENCY" class="talkgroup-item2">
                            <input v-if="showEmergencyGroup" type="radio" :id="'userTalkGroup-emergency-' + userTalkGroup.id" name="emergencygroup" :value="userTalkGroup.id" :disabled="appData.csvProcessing" :checked="userTalkGroup.emergencyFlag == 1 ? 'checked' : ''" @click="changeEmergencyGroup(userTalkGroup)" />
                        </td>
                        <!-- デフォルトセカンドグループ -->
                        <td class="talkgroup-item2">
                            <input v-if="showDefaultSecondGroup" type="radio" :id="'userTalkGroup-' + userTalkGroup.id" name="defaultsecondgroup" :value="userTalkGroup.id" :disabled="appData.csvProcessing" :checked="userTalkGroup.defaultSecondFlag == 1 ? 'checked' : ''" @click="changeDefaultSecondGroup(userTalkGroup)" />
                        </td>
                        <!-- 送信禁止グループ -->
                        <td v-if="FEATURE_JKC_SETTING_JOINED_GROUP" class="talkgroup-item2">
                            <label>
                              <input type="hidden" name="listenonly" :value="userTalkGroup.listenOnlyFlag" />
                              <input class="custom-checkbox-input" name="listenonly" value="True" type="checkbox">
                              <span v-if="userTalkGroup.listenOnlyFlag">
                                        <img class="action-icon" src="../../../../assets/icon_check_green.svg" @click="changeListenOnlyGroup(userTalkGroup)"/>
                                    </span>
                              <span v-else>
                                        <img class="action-icon" src="../../../../assets/icon_check_gray.svg" @click="changeListenOnlyGroup(userTalkGroup)"/>
                                    </span>
                            </label>
                        </td>
                        <!-- 削除 -->
                        <td v-if="showDeleteIpRadioGroupCommand" class="talkgroup-item2">
                            <button class="item-record-button" @click="removeTalkGroup(index)" type="button"><img src="../../../../assets/icon_delete_user.svg"/></button>
                        </td>
                    </tr>
                </table>
            </template>

        </el-tabs>

        <editipradio v-if="showEditIpRadio" :appData="appData" :userAttribute="userAttribute" :talkgroupInfos="talkGroupUsers" :isAdminUser="isAdminUser" @save="modifyIpRadio" @cancel="showEditIpRadio=false"></editipradio>
        <deletetalkgroup v-if="showDeleteTalkGroup" :confirmInfo="confirmInfo" @delete="removeFromTalkGroup" @cancel="showDeleteTalkGroup=false"></deletetalkgroup>
        <AssignIPRadioSetting :visible.sync="showAssignIpRadioSetting" :modelName="userAttribute.modelName" :originalSetting="userAttribute.ipRadioSetting" @save="assignIPRadioSetting"/>
        <addTalkgroupToUser v-if="showAddTalkGroupToUser" :appData="appData" :userAttribute="userAttribute" @save="updateTalkgroupUsersAfterDisappearDialog" @cancel="showAddTalkGroupToUser=false"></addTalkgroupToUser>
        <moveuser v-if="showMoveUser" :appData="appData" @move="moveUser" :sourceObjectId="userAttribute.id" @cancel="showMoveUser=false"></moveuser>
    </div>
</template>

<script>
import server from "../../../ServerApi.js";
import commonUtil from '../../../commonutil.js';
import constants from '../../../constants.js';
import AddTalkgroupToUser from "../../../AddTalkgroupToUser.vue";
import AssignIPRadioSetting from "../dialog/AssignIPRadioSetting.vue";
import EditIpRadio from "../../../EditIpRadio.vue";
import DeleteObject from "../../../DeleteObject.vue";
import MoveUser from "../../../MoveObject.vue";

import {
    FEATURE_JKC_STUN,
    FEATURE_JKC_SETTING_JOINED_GROUP
} from "@/components/feature_toggles/feature_toggle";
import {FEATURE_JKC_EMERGENCY} from "../../../feature_toggles/feature_toggle";

export default {
    components: {
        AddTalkgroupToUser,
        AssignIPRadioSetting,
        editipradio: EditIpRadio,
        deletetalkgroup: DeleteObject,
        moveuser: MoveUser,
    },

    props: {
        selectedNode: Object,
        appData: Object,
        listType: Number,
        tableView: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            MAX_USER_TALKGROUP_COUNT: 500,

            showTab: true,
            showDefaultGroup: true,
            showDefaultSecondGroup: true,
            showEmergencyGroup: true,
            showAddTalkGroupToUser: false,
            showDeleteTalkGroup: false,
            showAssignIpRadioSetting: false,
            showEditIpRadio: false,
            showMoveUser: false,

            confirmInfo: {
                objectName: null,
                objectTitle: null
            },
            groupCount: 0,
            usersTalkGroupExceededMax: false,
            ipRadioOptions: [],
            userAttribute: null ,
            talkGroupUsers: [],
            defaultSecondGroup: {tenantId: 0 , talkGroupId: 0 },
            removeTalkGroupIndex: 0,
            searchString: null,
            loadingScreen: null,
            condition: "all",
            selectedTabName: null,
            isAdminUser: false,
        };
    },

    computed: {
        constants() {
            return constants
        },
        useStatus() {
            if (this.userAttribute.existsToken) {
                return commonUtil.getMessageText(this.$i18n, 'item_in_use');
            } else {
                return commonUtil.getMessageText(this.$i18n, 'item_in_use_not');
            }
        },
        useStartDate() {
            if (this.userAttribute.existsToken) {
                const releaseDate = new Date(Date.UTC(2021, 9, 14, 18, 0, 0))
                const tokenCreateDate = new Date(this.userAttribute.tokenCreateDate)
                if (releaseDate > tokenCreateDate) {
                    return commonUtil.getMessageText(this.$i18n, 'info_no_available_use_start_date');
                }

                return tokenCreateDate.toLocaleString()
            } else {
                return '-'
            }
        },

        FEATURE_JKC_STUN: () => FEATURE_JKC_STUN,
        FEATURE_JKC_SETTING_JOINED_GROUP: () => FEATURE_JKC_SETTING_JOINED_GROUP,
        FEATURE_JKC_EMERGENCY: () => FEATURE_JKC_EMERGENCY,
        showMoveIpRadioCommand() {
            return commonUtil.canManageConsoleUserGroupDefinition(this.appData);
        },
        showAssignIpRadioSettingCommand() {
            return commonUtil.canManageRadioSettingAssignment(this.appData);
        },
        showEditIpRadioCommand() {
            return commonUtil.canEditIpRadioDisplayItems(this.appData);
        },
        showEditIpRadioGroupCommand() {
            return commonUtil.canManageConsoleUserTalkgroupAssignment(this.appData);
        },
        showDeleteIpRadioGroupCommand() {
            return commonUtil.canManageConsoleUserTalkgroupAssignment(this.appData);
        },

    },

    watch: {
        selectedNode: {
            handler(newVal, oldVal) {
                return this.getInfo();
            }
        },
        'appData.onlinePurchase'(newVal) {
            this.setIpRadioOptions(newVal);
            this.getInfo();
        }
    },

    created: function() {
        this.setIpRadioOptions(this.appData.onlinePurchase);
        this.selectedTabName = "ipRadioInfo";
        return this.getInfo();
    },

    methods: {
        getPrimaryLineDisplay(key) {
            return commonUtil.getIpRadioPrimaryLine(key);
        },
        getVersionDisplay(version) {
            return commonUtil.formatIpRadioVersionForDisplay(version);
        },
        getInfo: function() {
            if (this.selectedNode == null) {
                return;
            }
            let self = this;
            this.searchString = null;
            this.userAttribute = null;
            if (this.talkGroupUsers != null) {
                this.talkGroupUsers.splice(0,this.talkGroupUsers.length)
            }
            this.defaultSecondGroup.tenantId = 0;
            this.defaultSecondGroup.talkGroupId = 0;
            this.usersTalkGroupExceededMax = false;

            this.showLoadingScreen();

            server.post('/getinfo', {tenantId: this.appData.tenantList[0].tenantId, id: this.selectedNode.node.data.id, maxUserTalkgroupCount: this.MAX_USER_TALKGROUP_COUNT })
                .then((res) => {
                    self.closeLoadingScreen();
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            if (self.selectedNode.node.parent != null
                                && self.selectedNode.node.parent.data.id != null
                                && self.selectedNode.node.parent.data.id != res.data.pid) {
                                self.nodeInfo = null;
                                commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_already_moved").replace("{object}",commonUtil.getMessageText(self.$i18n,"item_user")));
                                self.$emit('refresh');
                                return;
                            }
                            if (self.tableView && self.selectedNode.node.parent != null) {
                                self.selectedNode.node.parent.data.id = res.data.pid;
                            }
                            if (res.data.talkgroups.length == 0) {
                                this.userSearchDisabled = true;
                            } else {
                                this.userSearchDisabled = false;
                            }
                            break;
                        case constants.STATUS_SUCCESS_WITH_ERRORINFO:
                            if (self.tableView && self.selectedNode.node.parent != null) {
                                self.selectedNode.node.parent.data.id = res.data.pid;
                            }
                            self.usersTalkgroupCount = res.data.talkgroups.length
                            self.usersTalkGroupExceededMax = true;
                            break;
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_not_have_read_permission_on_layer").replace("{object}",commonUtil.getMessageText(self.$i18n,"item_user")));
                            self.$emit('refresh');
                            return;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_already_deleted").replace("{object}",commonUtil.getMessageText(self.$i18n,"item_user")));
                            self.$emit('resetSelectedNode');
                            self.$emit('refresh');
                            return;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getInfo").replace("{code}",res.data.status));
                            return;
                    }
                    self.userAttribute = res.data;
                    self.isAdminUser = self.userAttribute.restrictions != null && self.userAttribute.restrictions.includes(constants.RESTRICTION_LOGIN);
                    self.getUserTalkGroupInfo(this.loadingScreen);
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "getInfo", error);
                    self.loadingScreen.close();
                });
        },
        getUserTalkGroupInfo(message) {
            this.showLoadingScreen();
            let self = this;
            self.groupCount = 0
            self.talkGroupUsers =[];
            self.userList = {}
            self.condition = "all";
            self.searchString = null;
            server.post('/getusertalkgroupinfo', { id: this.userAttribute.id })
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.groupCount = res.data.groupCount;
                            self.usersTalkGroupExceededMax = false;
                            break;
                        case constants.STATUS_SUCCESS_WITH_ERRORINFO:
                            self.groupCount = res.data.groupCount;
                            self.usersTalkGroupExceededMax = true;
                            break;
                        case constants.STATUS_ERROR_DENIED:
                            self.closeLoadingScreen();
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_get_user_talkgroup_info"));
                            return;
                        default:
                            self.closeLoadingScreen();
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getUserTalkGroupInfo").replace("{code}",res.data.status));
                            return;
                    }

                    let result = commonUtil.sortUserTalkGroup(self.appData, res.data.userTalkgroup, constants.OBJECT_TALKGROUP)
                    self.talkGroupUsers = result.sortedUserTalkGroup;
                    self.defaultSecondGroup = result.defaultSecondGroup;
                    self.closeLoadingScreen();
                    if (message != null) {
                        // need to set more delay time to show the message after close loading screen.
                        commonUtil.notifyMessageWithDuration(self, message.type, message.text, 2000);
                    }
                })
                .catch( function ( error ) {
                    self.closeLoadingScreen();
                    commonUtil.putExceptionErrorMessage(self, "getUserTalkGroupInfo", error);
                });
        },

        findNode(rootNode , nodeId) {
            let foundNode = null;
            if (nodeId == 1) {
                return rootNode;
            }
            for (let node of rootNode.childNodes) {
                if (node.data.id == nodeId) {
                    return node;
                }
                if (node.childNodes.length > 0) {
                    let foundNode = this.findNode(node , nodeId)
                    if (foundNode != null) {
                        return foundNode;
                    }
                }
            }
            return;
        },
        getInsertIndexOfUser: function(parentNode , insertObjectName) {
            let insertIndex = -1;
            let nodeLastIndex = -1;
            for (let i = 0 ; i < parentNode.childNodes.length ; i++) {
                if (parentNode.childNodes[i].data.type == 0) {
                    nodeLastIndex = i;
                } else if (parentNode.childNodes[i].data.type == 1) {
                    nodeLastIndex = i;
                } else if (parentNode.childNodes[i].data.type == 4) {
                    if (commonUtil.compareStringWithNumber(parentNode.childNodes[i].data.label, insertObjectName) < 0) {
                        insertIndex = i;
                    } else {
                        break;
                    }
                }
            }
            if (insertIndex == -1) {
                if (nodeLastIndex >= 0) {
                    insertIndex = nodeLastIndex;
                }
            }
            return insertIndex;
        },
        modifyIpRadio: function(input, userOptions) {
            this.$data.showEditIpRadio = false;

            let newDisplayName = null;
            if (input.displayName != this.userAttribute.displayName) {
                newDisplayName = input.displayName;
            }
            let newOrganization = null;
            if (input.organization != this.userAttribute.organization) {
                newOrganization = input.organization;
            }
            let newTitle = null;
            if (input.title != this.userAttribute.title) {
                newTitle = input.title;
            }
            let newPrimaryLine = null;
            if (input.primaryLine != this.userAttribute.primaryLine){
                newPrimaryLine = input.primaryLine;
            }
            let newCustomField1 = null;
            if (input.customField1 != this.userAttribute.customField1) {
                newCustomField1 = input.customField1;
            }
            let isStun = null;
            if (input.isStun != this.userAttribute.isStun) {
                isStun = input.isStun;
            }


            if (newDisplayName == null &&
                newOrganization == null &&
                newTitle == null &&
                newPrimaryLine == null &&
                newCustomField1 == null &&
                userOptions == null &&
                isStun == null
            ) {
                commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_no_change_information"));
                return;
            }

            let self = this;
            server.post(
                '/modifyipradio',
                {
                    operation:
                    {
                        id: this.$data.userAttribute.id,
                        newDisplayName: newDisplayName,
                        newOrganization: newOrganization,
                        newTitle: newTitle,
                        newPrimaryLine: newPrimaryLine,
                        newCustomField1: newCustomField1,
                        newUserOptions: userOptions,
                        isStun: isStun
                    }
                }
            ).then((res) => {
                if (res.data.status == constants.STATUS_SUCCESS) {
                    commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_modified_ip_radio"));
                    if (this.listType == 0) {
                        self.getInfo();
                    } else {
                        self.$emit('refresh');
                    }
                } else {
                    switch (res.data.status) {
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_not_have_write_permission_on_layer").replace('{object}',commonUtil.getMessageText(self.$i18n,"item_user")));
                            break;
                        case constants.STATUS_ERROR_ALREADY_EXISTED:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_modify_user_duplicateId"));
                            break;
                        case constants.STATUS_ERROR_OPTION_LICENSE_INSUFFICIENT:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_modify_user_insufficient_license"));
                            break;
                        case constants.STATUS_ERROR_OPTION_UNMATCH:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_modify_userOption"));
                            break;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_already_deleted").replace("{object}",commonUtil.getMessageText(self.$i18n,"item_user")));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","modifyIpRadio").replace("{code}",res.data.status));
                            break;
                    }
                    return;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "modifyUser", error);
            });
        },
        changeDefaultListenTalkgroup(targetUserTalkGroup) {
            let self = this;
            let parameter = { operation:
                    {
                        tenantId: targetUserTalkGroup.tenantId,
                        talkgroupId: targetUserTalkGroup.talkgroupId,
                        userTenantId: targetUserTalkGroup.userTenantId,
                        id: this.userAttribute.id
                    }
            };
            if (targetUserTalkGroup.defaultFlag == 1) {
                server.post("/resetdefaultlistentalkgroup", parameter)
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            targetUserTalkGroup.defaultFlag = 0;
                            commonUtil.notifyMessageWithDuration(self,"Success",commonUtil.getMessageText(self.$i18n,"info_reset_default_listen_group"), 4000);
                            return;
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_not_have_write_permission_on_layer").replace('{object}',commonUtil.getMessageText(self.$i18n,"item_user")));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","changeDefaultListenTalkgroup1").replace("{code}",res.data.status));
                            break;
                    }
                    return;
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "changeDefaultListenTalkgroup", error);
                });
            } else {
                server.post("/setdefaultlistentalkgroup", parameter)
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            targetUserTalkGroup.defaultFlag = 1;
                            commonUtil.notifyMessageWithDuration(self,"Success",commonUtil.getMessageText(self.$i18n,"info_change_default_listen_group"), 4000);
                            return;
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_not_have_write_permission_on_layer").replace('{object}',commonUtil.getMessageText(self.$i18n,"item_user")));
                            break;
                        case constants.STATUS_ERROR_TENANT_ALREADY_DELETED:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_tenant_already_deleted_talkgroup"));
                            break;
                        case constants.STATUS_ERROR_EXCEEDS_CONNECTED_TALKGROUP_LIMIT:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_connected_talkgroup_exceeded"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","changeDefaultListenTalkgroup2").replace("{code}",res.data.status));
                            break;
                    }
                    this.redrawDefaultGroup();
                    return;
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "changeDefaultListenTalkgroup", error);
                });
            }
        },
        changeDefaultSecondGroup(targetUserTalkGroup) {
            let self = this;
            let parameter = { operation:
                    {
                        tenantId: targetUserTalkGroup.tenantId,
                        talkgroupId: targetUserTalkGroup.talkgroupId,
                        userTenantId: targetUserTalkGroup.userTenantId,
                        id: this.userAttribute.id
                    }
            };
            if (targetUserTalkGroup.defaultSecondFlag == 1) {
                server.post("/resetdefaultsecondgroup", parameter)
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            targetUserTalkGroup.defaultSecondFlag = 0;
                            self.defaultSecondGroup.tenantId = 0;
                            self.defaultSecondGroup.talkGroupId = 0;
                            commonUtil.notifyMessageWithDuration(self,"Success",commonUtil.getMessageText(self.$i18n,"info_reset_default_second_group"), 4000);
                            return;
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_not_have_write_permission_on_layer").replace('{object}',commonUtil.getMessageText(self.$i18n,"item_user")));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","changeDefaultSecondGroup1").replace("{code}",res.data.status));
                            break;
                    }
                    return;
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "changeDefaultSecondGroup", error);
                });
            } else {
                server.post("/setdefaultsecondgroup", parameter)
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            let oldDefaultSecondGroup = self.talkGroupUsers.filter(function(userTalkGroup) {
                                return userTalkGroup.defaultSecondFlag == 1;
                            });
                            if (oldDefaultSecondGroup.length > 0) {
                                oldDefaultSecondGroup[0].defaultSecondFlag = 0;
                            }
                            targetUserTalkGroup.defaultSecondFlag = 1;
                            self.defaultSecondGroup.tenantId = targetUserTalkGroup.tenantId;
                            self.defaultSecondGroup.talkGroupId = targetUserTalkGroup.talkgroupId;
                            commonUtil.notifyMessageWithDuration(self,"Success",commonUtil.getMessageText(self.$i18n,"info_change_default_second_group"), 4000);
                            return;
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_not_have_write_permission_on_layer").replace('{object}',commonUtil.getMessageText(self.$i18n,"item_user")));
                            break;
                        case constants.STATUS_ERROR_TENANT_ALREADY_DELETED:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_tenant_already_deleted_talkgroup"));
                            break;
                        case constants.STATUS_ERROR_EXCEEDS_CONNECTED_TALKGROUP_LIMIT:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_connected_talkgroup_exceeded"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","changeDefaultSecondGroup2").replace("{code}",res.data.status));
                            break;
                    }
                    this.redrawDefaultSecondGroup();
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "changeDefaultSecondGroup", error);
                });
            }
        },
        changeEmergencyGroup(targetUserTalkGroup) {
            let self = this;
            let parameter = { operation:
                    {
                        tenantId: targetUserTalkGroup.tenantId,
                        talkgroupId: targetUserTalkGroup.talkgroupId,
                        userTenantId: targetUserTalkGroup.userTenantId,
                        id: this.userAttribute.id,
                        newFlag: targetUserTalkGroup.emergencyFlag == 1 ? 0 : 1
                    }
            };
            if (targetUserTalkGroup.emergencyFlag == 1) {
                server.post("/setemergencygroup", parameter)
                    .then((res) => {
                        switch (res.data.status) {
                            case constants.STATUS_SUCCESS:
                                targetUserTalkGroup.emergencyFlag = 0;
                                commonUtil.notifyMessageWithDuration(self, "Success", commonUtil.getMessageText(self.$i18n, "info_reset_emergency_group"), 4000);
                                return;
                            default:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","changeEmergencyGroupOff").replace("{code}",res.data.status));
                                break;
                        }
                    })
                    .catch( function ( error ) {
                        commonUtil.putExceptionErrorMessage(self, "changeEmergencyGroupOff", error);
                    });
            } else {
                server.post("/setemergencygroup", parameter)
                    .then((res) => {
                        switch (res.data.status) {
                            case constants.STATUS_SUCCESS:
                                let previousEmergencyGroup = self.talkGroupUsers.filter(function(userTalkGroup) {
                                    return userTalkGroup.emergencyFlag === 1;
                                });
                                if (previousEmergencyGroup.length > 0) {
                                    previousEmergencyGroup[0].emergencyFlag = 0;
                                }
                                targetUserTalkGroup.emergencyFlag = 1;
                                commonUtil.notifyMessageWithDuration(self, "Success", commonUtil.getMessageText(self.$i18n, "info_change_emergency_group"), 4000);
                                return;
                            case constants.STATUS_ERROR_OPTION_LICENSE_INSUFFICIENT_LINKED_TENANT:
                                commonUtil.notifyMessage(self, "Warning", commonUtil.getMessageText(self.$i18n, "error_cannot_modify_user_insufficient_license_linked_tenant"));
                                break;
                            default:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","changeEmergencyGroupOn").replace("{code}",res.data.status));
                                break;
                        }
                        this.redrawEmergencyGroup();
                    })
                    .catch( function ( error ) {
                        commonUtil.putExceptionErrorMessage(self, "changeEmergencyGroupOn", error);
                    });
            }
        },
        changePowerOnGroup(targetUserTalkGroup) {
            let self = this;
            let parameter = { operation:
                    {
                        tenantId: targetUserTalkGroup.tenantId,
                        talkgroupId: targetUserTalkGroup.talkgroupId,
                        userTenantId: targetUserTalkGroup.userTenantId,
                        id: this.userAttribute.id
                    }
            };
            if (targetUserTalkGroup.powerOnFlag === true) {
                server.post("/resetpowerongroup", parameter)
                    .then((res) => {
                        switch (res.data.status) {
                            case constants.STATUS_SUCCESS:
                                targetUserTalkGroup.powerOnFlag = false;
                                commonUtil.notifyMessageWithDuration(self,"Success",commonUtil.getMessageText(self.$i18n,"info_power_on_changed"), 4000);
                                return;
                            default:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","changePowerOnGroupOff").replace("{code}",res.data.status));
                                break;
                        }
                    })
                    .catch( function ( error ) {
                        commonUtil.putExceptionErrorMessage(self, "changePowerOnGroupOff", error);
                    });
            } else {
                server.post("/setpowerongroup", parameter)
                    .then((res) => {
                        switch (res.data.status) {
                            case constants.STATUS_SUCCESS:
                                let oldPowerOnGroup = self.talkGroupUsers.filter(function(userTalkGroup) {
                                    return userTalkGroup.powerOnFlag === true;
                                });
                                if (oldPowerOnGroup.length > 0) {
                                    oldPowerOnGroup[0].powerOnFlag = false;
                                }

                                targetUserTalkGroup.powerOnFlag = true;
                                commonUtil.notifyMessageWithDuration(self,"Success",commonUtil.getMessageText(self.$i18n,"info_power_on_changed"), 4000);
                                return;
                            case constants.STATUS_ERROR_EXCEEDS_CONNECTED_TALKGROUP_LIMIT:
                                commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_connected_talkgroup_exceeded"));
                                break;
                            default:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","changePowerOnGroupOn").replace("{code}",res.data.status));
                                break;
                        }
                    })
                    .catch( function ( error ) {
                        commonUtil.putExceptionErrorMessage(self, "changePowerOnGroupOn", error);
                    });
            }
        },
        changeListenOnlyGroup(targetUserTalkGroup) {
            let self = this;
            let parameter = { operation:
                    {
                        tenantId: targetUserTalkGroup.tenantId,
                        talkgroupId: targetUserTalkGroup.talkgroupId,
                        userTenantId: targetUserTalkGroup.userTenantId,
                        id: this.userAttribute.id
                    }
            };
            if (targetUserTalkGroup.listenOnlyFlag === true) {
                server.post("/resetlistenonlygroup", parameter)
                    .then((res) => {
                        switch (res.data.status) {
                            case constants.STATUS_SUCCESS:
                                targetUserTalkGroup.listenOnlyFlag = false;
                                commonUtil.notifyMessageWithDuration(self,"Success",commonUtil.getMessageText(self.$i18n,"info_listen_only_changed"), 4000);
                                return;
                            default:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","changeListenOnlyGroupOff").replace("{code}",res.data.status));
                                break;
                        }
                    })
                    .catch( function ( error ) {
                        commonUtil.putExceptionErrorMessage(self, "changeListenOnlyGroupOff", error);
                    });
            } else {
                server.post("/setlistenonlygroup", parameter)
                    .then((res) => {
                        switch (res.data.status) {
                            case constants.STATUS_SUCCESS:
                                targetUserTalkGroup.listenOnlyFlag = true;
                                commonUtil.notifyMessageWithDuration(self,"Success",commonUtil.getMessageText(self.$i18n,"info_listen_only_changed"), 4000);
                                return;
                            default:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","changeListenOnlyGroupOn").replace("{code}",res.data.status));
                                break;
                        }
                    })
                    .catch( function ( error ) {
                        commonUtil.putExceptionErrorMessage(self, "changeListenOnlyGroupOn", error);
                    });
            }
        },
        updateTalkgroupUsersAfterDisappearDialog(input) {
            // dialog will not be disappeared immediately when a lot of users in the tenant
            // update talkGroup users after disappear(DOM element of dialog not found) the dialog
            this.showAddTalkGroupToUser=false;
            let self = this;
            let timer = setInterval(
                function() {
                    if (document.getElementById("addTalkgroupToUser") == null) {
                        clearInterval(timer);
                        self.closeLoadingScreen();
                        self.updateTalkgroupUsers(input);
                    }
                }
            ,100);
        },
        updateTalkgroupUsers(input) {
            this.showAddTalkGroupToUser=false;
            let operations = [];

            // create addtotalkgroup request parameter
            for (let key in input.addTagList) {
                let tag = input.addTagList[key]
                operations.push({
                     command: "addtotalkgroup",
                     operation: {
                         tenantId: tag.tenantId,
                         talkgroupId: tag.talkgroupId,
                         userTenantId: this.appData.tenantList[0].tenantId,
                         userId: this.userAttribute.id,
                     }
                 })
            }

            // create removefromtalkgroup request parameter
            for (let key in input.removeTagList) {
                let tag = input.removeTagList[key]
                operations.push({
                    command: "removefromtalkgroup",
                    operation: {
                        tenantId: tag.tenantId,
                        talkgroupId: tag.talkgroupId,
                        userTenantId: this.appData.tenantList[0].tenantId,
                        userId: this.userAttribute.id
                    }
                })
            }

            let self = this;

            if (operations.length == 0) {
                commonUtil.notifyMessage(self,"Info",commonUtil.getMessageText(self.$i18n,"info_no_changing_information"));
                return;
            }

            server.post('/multiop', {operations: operations})
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.getUserTalkGroupInfo({type: "Success", text:commonUtil.getMessageText(self.$i18n,"info_modified_participant_group_of_user")});
                            if (self.tableView) {
                                self.$emit('refresh');
                            }
                            break;
                        case constants.STATUS_ERROR_BATCH_PROCESS:
                            if (res.data.errorInfo.length > 0 && res.data.errorInfo[0].errorCode === constants.STATUS_ERROR_EXCEEDS_MAX_COUNT) {
                                commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_modify_user_in_alert_group_for_exceed"));
                                break;
                            }
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_modify_participated_group_access_denied"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","updateTalkgroupUsers").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "updateTalkgroupUsers", error);
                });
        },
        filterTalkGroup() {
            let param = { id: this.userAttribute.id };
            if (this.condition == "name") {
                if (this.searchString != "") {
                    param.searchName = this.searchString;
                } else {
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(self.$i18n,"error_input_search_condition"));
                    return;
                }
            } else if (this.condition == "mandatoryYes") {
                param.searchMandatory = true;
            } else if (this.condition == "mandatoryNo") {
                param.searchMandatory = false;
            } else {
                if (this.condition == "all") {
                    this.searchString = "";
                    this.getUserTalkGroupInfo(null);
                }
            }
            let self = this;
            self.talkGroupUsers = [];
            server.post('/getusertalkgroupinfo', param)
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.usersTalkGroupExceededMax = false;
                            break;
                        case constants.STATUS_SUCCESS_WITH_ERRORINFO:
                            self.usersTalkGroupExceededMax = true;
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","filterTalkGroup").replace("{code}",res.data.status));
                            return;
                    }
                    if (res.data.userTalkgroup.length == 0) {
                        commonUtil.notifyMessage(self,"Info",commonUtil.getMessageText(self.$i18n,"info_group_not_found"));
                        return;
                    }
                    let result = commonUtil.sortUserTalkGroup(self.appData, res.data.userTalkgroup, constants.OBJECT_TALKGROUP)
                    self.talkGroupUsers = result.sortedUserTalkGroup;
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "filterTalkGroup", error);
                });
        },
        clearSearchString() {
            this.searchString = "";
        },
        removeTalkGroup: function(index) {
            if (this.appData.csvProcessing) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_import_processing"));
                return;
            }
            if (this.talkGroupUsers[index].tenantId != this.appData.tenantList[0].tenantId) {
                let externalGroup = false;
                for (let exportedTenant of this.appData.exportedTenantList) {
                    if (exportedTenant.tenantId == this.talkGroupUsers[index].tenantId) {
                        externalGroup = true;
                        break;
                    }
                }
                if (externalGroup) {
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_remove_group_by_link"));
                    return;
                }
            }
            this.removeTalkGroupIndex = index;
            this.confirmInfo.objectTitle = commonUtil.getMessageText(this.$i18n,"title_userGroup");
            this.confirmInfo.objectName = this.talkGroupUsers[index].talkgroupName;
            this.$data.showDeleteTalkGroup = true;
        },
        removeFromTalkGroup: function() {
            this.showDeleteTalkGroup = false;
            let self = this;
            server.post(
                '/removefromtalkgroup',
                {
                    operation:
                    {
                        tenantId: this.talkGroupUsers[this.removeTalkGroupIndex].tenantId ,
                        talkgroupId: this.talkGroupUsers[this.removeTalkGroupIndex].talkgroupId ,
                        userTenantId: this.talkGroupUsers[this.removeTalkGroupIndex].userTenantId ,
                        userId: this.userAttribute.id
                    }
                }
            ).then((res) => {
                switch(res.data.status) {
                    case constants.STATUS_SUCCESS:
                        self.talkGroupUsers.splice(self.removeTalkGroupIndex,1);
                        commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_deleted_groupOfUser"));
                        if (self.tableView) {
                            self.$emit('refresh');
                        }
                        break;
                    case constants.STATUS_ERROR_DENIED:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_modify_participated_group_access_denied"));
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","removeFromTalkGroup").replace("{code}",res.data.status));
                        break;
                }
                self.getInfo();
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "removeFromTalkGroup", error);
            });
        },

        async showDialogAfterWritableCheck(functionName) {
            if (functionName === "AssignIPRadioSetting" && commonUtil.canManageRadioSettingAssignment(this.appData)) {
                this.showAssignIpRadioSetting = true;
                return;
            }
            if (functionName === "EditIpRadio" && commonUtil.canEditIpRadioDisplayItems(this.appData)) {
                this.showEditIpRadio = true;
                return;
            }

            if (functionName === "MoveUser" && !commonUtil.canManageConsoleUserGroupDefinition(this.appData)) {
                return;
            }
            if (functionName === "AddTalkGroupToUser" && !commonUtil.canManageConsoleUserTalkgroupAssignment(this.appData)) {
                return;
            }

            if (this.appData.csvProcessing) {
                commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_import_processing"));
                return;
            }
            const parentId = this.selectedNode?.node?.parent?.data?.id;
            if (parentId == null) {
                commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_not_have_write_permission_on_layer").replace('{object}', commonUtil.getMessageText(this.$i18n, "item_user")));
                return;
            }

            let res;
            try {
                res = await server.post('/getinfo', {
                    tenantId: this.appData.tenantList[0].tenantId,
                    id: parentId
                })
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "showDialogAfterWritableCheck", error);
            }

            if (res.data.status !== constants.STATUS_SUCCESS) {
                commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_not_have_write_permission_on_layer").replace('{object}', commonUtil.getMessageText(this.$i18n, "item_user")));
                return;
            }

            let myAclId = this.appData.tenantList[0].tenantId + "-" + this.appData.loginUserObjectId;
            let acl = JSON.parse(res.data.acl)
            if (acl.rw == null) {
                // no writable acl info
                commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_not_have_write_permission_on_layer").replace('{object}', commonUtil.getMessageText(this.$i18n, "item_user")));
                return;
            }

            let writable = acl.rw.find(function (element) {
                return element === myAclId;
            });
            if (writable == null) {
                commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_not_have_write_permission_on_layer").replace('{object}', commonUtil.getMessageText(this.$i18n, "item_user")));
                return;
            }

            switch (functionName) {
                case "AddTalkGroupToUser":
                    this.showAddTalkGroupToUser = true;
                    break;
                case "AssignIPRadioSetting":
                    this.showAssignIpRadioSetting = true;
                    break;
                case "EditIpRadio":
                    this.showEditIpRadio = true;
                    break;
                case "MoveUser":
                    this.showMoveUser = true;
                    break;
            }
        },
        moveUser: function(destinationNodeId) {
            this.$data.showMoveUser = false;
            let self = this;
            server.post(
                '/move',
                {
                    operation:
                    {
                        id: this.$data.userAttribute.id ,
                        destinationId: destinationNodeId
                    }
                }
            ).then((res) => {
                if (res.data.status == constants.STATUS_SUCCESS) {
                    commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_moved_user"));
                    if (this.listType == 0) {
                        // this operation only performed when select the object from tree.
                        let parentNode = self.findNode(self.selectedNode.tree.$children[0].node , destinationNodeId);
                        if (parentNode != null) {
                            // parent node already loaded
                            var insertData = { data :
                                                {
                                                    tenantId: self.selectedNode.node.data.tenantId,
                                                    id: self.selectedNode.node.data.id,
                                                    label: self.selectedNode.node.data.label,
                                                    type: 4,
                                                    restrictions: self.selectedNode.node.data.restrictions,
                                                    isLeaf: true
                                                 }
                                             };
                            this.insertNewUserToTree(insertData, parentNode);
                        }
                        self.selectedNode.node.parent.removeChild(self.selectedNode.node);
                    } else {
                        self.$emit('refresh');
                    }
                } else {
                    if ((res.data.status === constants.STATUS_ERROR_DENIED) && (self.isAdminUser)) {
                        commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_move_consoleadmin_from_root"));
                    } else {
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","moveUser").replace("{code}",res.data.status));
                    }
                    return;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "moveUser", error);
            });
        },
        insertNewUserToTree(insertData , parentNode) {
            if (parentNode.childNodes.length == 0) {
                parentNode.insertChild(insertData,0)
                parentNode.expand();
                return;
            }

            var insertIndex = this.getInsertIndexOfUser(parentNode , insertData.data.label);
            if (insertIndex < 0) {
                parentNode.insertBefore(insertData,parentNode.childNodes[0]);
            } else {
                parentNode.insertAfter(insertData,parentNode.childNodes[insertIndex]);
            }
        },

        handleChangeMandatory(talkgroupUser) {
            if (this.appData.csvProcessing) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_import_processing"));
                return;
            }
            this.showLoadingScreen();
            let operations = [];
            let newFlag = 1;
            if (talkgroupUser.mandatoryFlag) {
                newFlag = 0;
            }
            let param = {
                tenantId: talkgroupUser.tenantId,
                talkgroupId: talkgroupUser.talkgroupId,
                userTenantId: this.appData.tenantList[0].tenantId,
                userId: this.userAttribute.id,
                newFlag: newFlag
            }
            let self = this;
            server.post('/setmandatorygroupuser', {operation: param}
            ).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        self.closeLoadingScreen();
                        talkgroupUser.mandatoryFlag = newFlag;
                        commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_mandatory_changed"));
                        break;
                    case constants.STATUS_ERROR_EXCEEDS_MANDATORY_LIMIT:
                        self.closeLoadingScreen();
                        commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_mandatory_group_exceeded"));
                        break;
                    case constants.STATUS_ERROR_EXCEEDS_CONNECTED_TALKGROUP_LIMIT:
                        self.closeLoadingScreen();
                        commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_connected_talkgroup_exceeded"));
                        break;
                    case constants.STATUS_ERROR_DENIED:
                        self.closeLoadingScreen();
                        commonUtil.notifyMessage(self,"Warning", commonUtil.getMessageText(self.$i18n,"error_mandatory_access_denied").replace("{object}",commonUtil.getMessageText(self.$i18n,"item_user")));
                        break;
                    case constants.STATUS_ERROR_TENANT_ALREADY_DELETED:
                        self.closeLoadingScreen();
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_tenant_already_deleted_talkgroup"));
                        break;
                    case constants.STATUS_ERROR_OPTION_UNMATCH:
                        self.closeLoadingScreen();
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_mandatory_group_on_alert_group"));
                        break;
                    default:
                        self.closeLoadingScreen();
                        commonUtil.notifyMessage(self,"Error", commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","handleChangeMandatory").replace("{code}",res.data.status));
                        break;
                }
                return;
            })
                .catch( function ( error ) {
                    self.closeLoadingScreen();
                    commonUtil.putExceptionErrorMessage(self, "handleMandatoryChange", error);
                });
        },
        handleChangeSearchCondition() {
            if ((this.condition == "mandatoryYes") || ((this.condition == "mandatoryNo"))) {
                this.filterTalkGroup();
            }
            if (this.condition == "all") {
                this.getUserTalkGroupInfo(null);
            }
        },
        setIpRadioOptions: function(onlinePurchase) {
            let ipRadioOptions;
            if (onlinePurchase) {
                ipRadioOptions = commonUtil.getUserOptionForOnline(this.$i18n);
            } else {
                ipRadioOptions = commonUtil.getUserOption(this.$i18n);
            }

            this.ipRadioOptions = [];
            for (var i = 0 ; i < ipRadioOptions.length ; i++ ) {
                this.ipRadioOptions.push({displayName: ipRadioOptions[i].name, shift: ipRadioOptions[i].shift, value: false});
            }
        },

        async assignIPRadioSetting(settingId, model, displayName) {
            let response
            try {
                response = await server.post('/assignsettingtoipradio',
                {
                        ipRadioSettingId: settingId,
                        ipRadioList:[this.selectedNode.node.data.id]
                    })
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "assignIPRadioSetting", error);
            }

            const responseStatus = response.data.status;
            switch (responseStatus) {
                case constants.STATUS_SUCCESS:
                    commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n,"info_modified_assignment_ipradio_setting"));

                    if (!this.userAttribute.ipRadioSetting) {
                        this.$set(this.userAttribute, 'ipRadioSetting', {});
                    }

                    Object.assign(this.userAttribute.ipRadioSetting, {
                        id: settingId,
                        model,
                        displayName,
                    });
                    break;
                case constants.STATUS_ERROR_NOT_FOUND:
                    commonUtil.notifyMessage(this, "Warning", "指定された無線機設定がありません。");
                    break;
                case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                    commonUtil.notifyMessage(this, "Warning", "指定されたユーザーが存在しません。");
                    break;
                default:
                    commonUtil.putExceptionErrorMessage(this, "updateSetting", response.data.status);
                    break;
            }
        },

        handleChangeTab() {
            if (this.selectedTabName == "userGroup") {
                this.getUserTalkGroupInfo(null);
            }
            this.reDrawTab();
        },
        beforeLeave(activeName, oldActiveName) {
            if (activeName == "userGroup") {
                this.showLoadingScreen();
            }
            return true;
        },
        showLoadingScreen() {
            if (this.loadingScreen == null) {
                this.loadingScreen = this.$loading({
                        lock: true ,
                        text: 'Loading data ...' ,
                        spinner: 'el-icon-loading' ,
                        background: 'rgba(0, 0, 0, 0)'
                });
            }
        },
        closeLoadingScreen() {
            if (this.loadingScreen != null) {
                this.loadingScreen.close();
                this.loadingScreen = null;
            }
        },
        reDrawTab() {
            // some of message of old tab was remained in new tab.
            // it can clear by redraw
            this.showTab = false;
            this.$nextTick(() => {
                 this.showTab = true
            })
        },
        redrawDefaultGroup() {
            // reset displayed default flag by reDraw
            this.showDefaultGroup = false;
            this.$nextTick(() => {
                 this.showDefaultGroup = true
            })
        },
        redrawDefaultSecondGroup() {
            // reset displayed default second flag by reDraw
            this.showDefaultSecondGroup = false;
//            this.showDefaultSecondGroup = true;
            this.$nextTick(() => {
                 this.showDefaultSecondGroup = true
            })
        },
        redrawEmergencyGroup() {
            this.showEmergencyGroup = false;
            this.$nextTick(() => {
                 this.showEmergencyGroup = true
            })
        },
        isVisibleUserOption(optionName) {
            if (this.appData.basicContract.planType == constants.LICENSE_PLAN_SEPARATE) {
                return commonUtil.isVisibleUserOption(this.appData.onlinePurchase, optionName);
            } else {
                return true;
            }
        },
        getMessageText(messageId) {
            return commonUtil.getMessageText(this.$i18n, messageId);
        },
    }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
li {
  list-style:none;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
.panel {
    background: #fff;
    padding: 20px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -150px;
    margin-top: -100px;
    transition: all .3s ease;
}
.modal-default-button {
  float: right;
}

input[type="radio"]{
    outline: 0;
     -webkit-appearance: none;
    position: relative;
    display: inline-block;
    width: 20px;
    height: 20px;
    background: url(../../../../assets/icon_check_gray.svg);
}
input[type="radio"]:checked {
    outline: 0;
    width: 20px;
    height: 20px;
    background: url(../../../../assets/icon_check_green.svg);
}
input[type="radio"]:hover {
     cursor : pointer;
}
.talkgroup-title {
    width: 100%;
    padding: 10px 0 10px 28px;
    display: table-row;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
    background-color: #f6f6f6;
}
.talkgroup-item-header1 {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 12px;
}
.talkgroup-item-header2 {
    padding-top: 10px;
    padding-bottom: 10px;
    width: 15%;
    text-align:center;
}
.talkgroup-item-record {
    border-bottom:1px #eee solid;
}
.talkgroup-item-record:hover {
    background-color: #ecf1fa;
}
.talkgroup-item1 {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 28px;
    font-size: 14px;
}
.talkgroup-item2 {
    text-align: center;
}

.talkgroup-item-header1,
.talkgroup-item1 {
    width: 250px;        /* ←少し広めに確保 */
    white-space: nowrap; /* 改行禁止 */
    overflow: hidden;
    text-overflow: ellipsis;
}

.talkgroup-item-header2,
.talkgroup-item2 {
    width: 80px;       /* ←%ではなくpx指定にすると安定 */
    text-align: center;
}

.el-select-dropdown__item {
    font-size: 12px;
}
.el-select-dropdown__item selected {
    color: #5171cb;
}

.custom-checkbox-input {
  display: none;
}

.action-icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
}

.el-tabs--border-card {
    box-shadow: none !important;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item:not(.is-disabled):hover {
    color: #5171cb;
    opacity: 0.7;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item.is-active {
    color: #848991;
    background: #f6f6f6;
    border: none;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item {
    color: #5171cb;
    background: #ecf1fa;
}
.el-tabs__nav-scroll {
    background: #ecf1fa;
}
.el-tabs--border-card >>> .el-tabs__header {
    border: none;
    background: #ecf1fa;
}
.el-tabs--border-card >>> .el-tabs__content {
    padding: 0px;
}
.el-tabs--border-card {
    border: none;
}
</style>
